export default __webpack_public_path__ + "static/media/10.5f9ca72e.jpg";